module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centerdiv"
  }, [_c('h2', [_vm._v("公告管理")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 9
    }
  }, [_vm._v("发布新公告")]), _vm._v(" "), _c('el-col', {
    staticClass: "textleft",
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.noticeText),
      callback: function($$v) {
        _vm.noticeText = $$v
      },
      expression: "noticeText"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "textleft",
    attrs: {
      "span": 9
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.add_new_notice
    }
  }, [_vm._v("发布")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35e92c56"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/noticePage.vue
// module id = 640
// module chunks = 9